import { render, staticRenderFns } from "./BaseMitDataTable.vue?vue&type=template&id=7f78f493&scoped=true"
import script from "./BaseMitDataTable.vue?vue&type=script&lang=js"
export * from "./BaseMitDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78f493",
  null
  
)

export default component.exports